import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Checkbox } from "@/components/ui/checkbox";
import { CHARTS } from "@/lib/reports";

const eur = (v) => (v == null ? "n/c" : `${Math.round(v).toLocaleString("fr-FR")} €`);
const short = (v) => (Math.abs(v) >= 1_000_000 ? `${(v / 1_000_000).toFixed(1)} M€` : Math.abs(v) >= 1000 ? `${Math.round(v / 1000)} k€` : `${v} €`);
const CHART_MARGIN = { top: 6, right: 10, left: 0, bottom: 0 };
const AXIS_TICK = { fontSize: 11 };
const TOOLTIP_STYLE = { borderRadius: 8, fontSize: 12 };
const DOT = { r: 3.5 };

export default function ReportCharts({ history, selected = [], onToggle, disabled }) {
    const rows = (history || []).filter((h) => h.exercice);
    if (rows.length < 2) return <p data-testid="report-charts-empty" className="text-xs text-muted-foreground">Historique insuffisant pour les graphiques (au moins 2 exercices dans le FEC ou les KPI).</p>;
    return (
        <div data-testid="report-charts" className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {CHARTS.map((c) => {
                const has = rows.some((r) => r[c.key] != null);
                if (!has) return null;
                const on = selected.includes(c.key);
                return (
                    <div key={c.key} data-testid={`chart-${c.key}`} className="rounded-xl border border-slate-200 bg-white shadow-sm p-3 space-y-2">
                        <div className="flex items-center justify-between">
                            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">{c.label}</p>
                            <label className="flex items-center gap-2 text-xs text-muted-foreground cursor-pointer">
                                <Checkbox data-testid={`chart-include-${c.key}`} checked={on} disabled={disabled} onCheckedChange={() => onToggle?.(c.key)} /> Inclure au PDF
                            </label>
                        </div>
                        <div className="h-40 w-full min-w-0">
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={rows} margin={CHART_MARGIN}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                                    <XAxis dataKey="exercice" tick={AXIS_TICK} stroke="hsl(var(--muted-foreground))" />
                                    <YAxis tickFormatter={short} tick={AXIS_TICK} stroke="hsl(var(--muted-foreground))" width={64} />
                                    <Tooltip formatter={(v) => eur(v)} contentStyle={TOOLTIP_STYLE} />
                                    <Line type="monotone" dataKey={c.key} name={c.label} stroke={c.color} strokeWidth={2.2} dot={DOT} connectNulls />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
